import React, { useState } from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import { graphql, useStaticQuery } from 'gatsby';

const Testimonial = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        testimonials_heading
        testimonials {
          id
          by
          description
          image {
            publicURL
          }
        }
      }
    }
  `);

  const {
    strapiHomePage: { testimonials_heading, testimonials },
  } = data;
  const [swiper, setSwiper] = useState(null);

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  return (
    <section className='testimonials-one' id='testimonials'>
      <div className='container'>
        <div className='block-title text-center'>
          <h2 className='block-title__title'>{testimonials_heading}</h2>
        </div>
        <div className='testimonials-one__carousel-outer'>
          <div className='testimonials-one__carousel'>
            <Swiper getSwiper={setSwiper}>
              {testimonials.map((testimonial) => {
                return (
                  <div className='item' key={testimonial.id}>
                    <div className='testimonials-one__single'>
                      <div className='testimonials-one__inner'>
                        <p>{testimonial.description}</p>
                        <h3>{testimonial.by}</h3>
                        <span>Our Customers</span>
                        <img src={testimonial.image.publicURL} alt='person' />
                      </div>
                    </div>
                  </div>
                );
              })}
            </Swiper>
          </div>
          <div className='testimonials-one__carousel__shape-one'></div>
          <div className='testimonials-one__carousel__shape-two'></div>
          <div className='testimonials-one__nav'>
            <div
              onClick={goPrev}
              onKeyDown={goPrev}
              role='button'
              tabIndex='-1'
              className='testimonials-one__nav-left'
            >
              <i className='dimon-icon-left-arrow'></i>
            </div>
            <div
              onClick={goNext}
              onKeyDown={goNext}
              role='button'
              tabIndex='-1'
              className='testimonials-one__nav-right'
            >
              <i className='dimon-icon-right-arrow'></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Testimonial;
